import { type Observable } from '@legendapp/state';
import { createPersistedStore } from '@kidslabs/module-core';

export type CartItemReferenceSynchronizationStore = {
    syncStatus?: 'idle' | 'loading' | 'error' | 'success';
    /** Incremented after every successful sync. Consumers can watch this to
     *  know "cart just synced" vs "idle but never synced". */
    syncVersion?: number;
};

const initialState: CartItemReferenceSynchronizationStore = {
    syncStatus: 'idle',
    syncVersion: 0,
};

/**
 * Cart Item Reference Synchronization store with automatic IndexedDB persistence
 *
 * ✅ Auto-registers as 'cartItemReferenceSynchronization'
 * ✅ No manual SSR checks needed
 * ✅ Automatic persistence on client-side
 */
export const cartItemReferenceSynchronizationStore$: Observable<CartItemReferenceSynchronizationStore> =
    createPersistedStore<CartItemReferenceSynchronizationStore>('cartItemReferenceSynchronization', initialState);
